import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import numeral from 'numeral';

import OtherRatesForm from './OtherRatesForm';

import DataTable from '../../../components/DataTable';
import Modal from '../../../components/Modal';
import Page from '../../../components/Page';

import BlankState from '../../../components/BlankState';

import { listPartners } from '../../../actions/brokers';
import { listCovers } from '../../../actions/openCovers';
import { fetchOtherRates } from '../../../actions/rates';

class OtherRates extends Component{

    constructor(props){
        super(props);
        const { user } = this.props;

        this.state = {
            activeFilter: {},
            filter: {
                insurer: user.userInfo.insurer
            },
            otherRates: {},
            activeRate: {}
        };
    }

    componentDidMount(){
        const { listPartners, listCovers } = this.props;

        listPartners(this.state.filter);
        listCovers();
        
        this.filterRates();
    }

    componentWillReceiveProps(nextProps) {
        const { otherRates } = nextProps.rates || {};

        if(otherRates){
            const newRates = otherRates.length > 0 ? otherRates[otherRates.length - 1] : {};

            this.setState({
                otherRates: {
                    ...newRates,
                    ...this.state.filter
                }
            });
        }
    }

    filterRates(){
        this.props.fetchOtherRates(this.state.filter);
    }

    onChangeFilter = (e) => {
        e.preventDefault();
        const { name, value } = e.target;
        const { filter, otherRates } = this.state;

        this.setState({
            filter: {
                insurer: filter.insurer,
                [name]: value
            },
            otherRates: {
                insurer: filter.insurer,
                ...otherRates,
                [name]: value
            }
        }, ()=>{
            this.filterRates();
        });
    }

    selectFilterType = (e) => {
        this.setState({
            activeFilter: e.target.value
        });
    }

    editOtherRates = (otherRates) => {
        this.setState({
            activeRate: otherRates
        });
    }
    
    resetRatesForm = () => {
        this.setState({
            activeRate: {}
        })
    }

    render(){
        console.log(this.state);

        const { brokers, covers, rates } = this.props;
        const {  activeFilter, activeRate } = this.state;


    	return(
    		<Page isAdminPage={ true } pageTitle="Other Rates">

                <div className="card">
                    <form className="form-inline filter-form row clearfix">
                        <div className="col-sm-4 col-md-3">
                            <select 
                                name="filter" 
                                className="form-control"
                                onChange={ this.selectFilterType }>

                                <option value="">- Filter by -</option>
                                <option value="partnership">Filter by Broker Partnership</option>
                                <option value="opencover">Filter by Open Cover</option>
                            </select>
                        </div>
                        <div className="col-sm-4 col-md-3">
                        {
                            activeFilter === 'partnership' ?

                                <select 
                                    name="intermediary_partnership" 
                                    className="form-control"
                                    onChange={ this.onChangeFilter }>

                                    <option value="">- Select a Broker Partnership -</option>
                                    {
                                        brokers.partners.map((partner, index)=>{
                                            return(
                                                <option key={ index } value={ partner.id }>
                                                    { partner.intermediary_name }
                                                </option>
                                            )
                                        })
                                    }
                                </select>
                            : null
                        }
                        {
                            activeFilter === 'opencover' ?

                                <select 
                                    name="corporate_client" 
                                    className="form-control"
                                    onChange={ this.onChangeFilter }>

                                    <option value="">- Select Open Cover -</option>
                                    {
                                        covers.openCovers.map((cover, index)=>{
                                            return(
                                                <option key={ index } value={ cover.company }>
                                                { cover.company_name }
                                                </option>
                                            )
                                        })
                                    }
                                </select>
                            : null
                        }
                        </div>
                    </form>
                    
                    <hr/>

                    <button
                        data-toggle="modal"
                        data-target=".other-rates-modal"
                        className="btn btn-sm btn-success">

                        <i className="icon ion-plus"></i> Add New Rates
                    </button>
                    <br/>
                    <br/>

                    {
                        rates.otherRates.length > 0 ?
                            <DataTable
                                tableId="other-rates-table"
                                sortOrder={[0, 'asc']}
                                columnTitles={ ['Insurer', 'Rates Type', 'Name', 'Minimum Premium', 'Warehousing', 
                                    'Transhipment', 'War Risk', 'Actions'] }>

                            {
                                rates.otherRates.map((otherRate, index) => {
                                    const {  insurer_name, corporate_client, minimum_premium, 
                                        intermediary_partnership, warehousing, transhipment, war_risk } = otherRate;
                                    
                                    const filteredPartner = brokers.partners.filter(partner => {
                                        return partner.id === intermediary_partnership;
                                    });
                                    const filteredOpenCover = covers.openCovers.filter(openCover => {
                                        return openCover.company === corporate_client;
                                    });

                                    return (
                                        <tr key={ index }>
                                            <td>{ insurer_name }</td>
                                            <td>
                                                { 
                                                    corporate_client ?
                                                        <span className="label label-info">Open Cover</span> 
                                                    : null
                                                }
                                                {
                                                    intermediary_partnership ?
                                                        <span className="label label-primary">Broker Partnership</span>
                                                    : null
                                                }
                                                { !intermediary_partnership && !corporate_client ? '-' : null }
                                            </td>
                                            <td>
                                                {
                                                    filteredPartner.length > 0 ? filteredPartner[0].intermediary_name : null
                                                    || 
                                                    filteredOpenCover.length > 0 ? filteredOpenCover[0].company_name : null
                                                    ||
                                                    '-'
                                                }
                                            </td>
                                            <td>{ numeral(minimum_premium).format('0,0.00') }</td>
                                            <td>{ parseFloat(warehousing) }</td>
                                            <td>{ parseFloat(transhipment) }</td>
                                            <td>{ parseFloat(war_risk) }</td>
                                            <td>
                                                <button
                                                    data-toggle="modal"
                                                    data-target=".other-rates-modal"
                                                    className="btn btn-sm btn-warning"
                                                    onClick={ ()=>{ this.editOtherRates(otherRate) } }>

                                                    <i className="icon ion-edit"></i> Edit
                                                </button>
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                            </DataTable>
                        :
                            <div className="clearfix">
                                <BlankState
                                    data={ rates.otherRates }
                                    dataName="Other Rates"
                                    isDataLoading={ rates.otherRatesLoading } />
                            </div>
                    }

                    <Modal 
                        title="Other Rates"
                        className="other-rates-modal"
                        closable={ true }
                        onCloseFn={ this.resetRatesForm }>

                        <OtherRatesForm otherRate={ activeRate } />
                    </Modal>
                </div>
			</Page>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    user: state.user,
    brokers: state.brokers,
    covers: state.covers,
    rates: state.rates
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ listPartners, listCovers, fetchOtherRates }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(OtherRates);


// WEBPACK FOOTER //
// ./src/pages/dashboard/rates/OtherRates.jsx